import React from "react";

/**
 * Camada de fundo viva: manchas de luz que respiram + grade sutil.
 * Puramente decorativa — fica atrás de tudo e ignora o ponteiro.
 */
const Aurora = ({ variant = "light", className = "" }) => {
  const dark = variant === "dark";

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      <div
        className={`absolute inset-0 ${
          dark ? "bg-grid-dark" : "bg-grid-light"
        } bg-grid [mask-image:radial-gradient(70%_60%_at_50%_35%,#000,transparent)]`}
      />

      <div
        className="aurora-blob animate-drift"
        style={{
          top: "-14%",
          left: "-8%",
          width: "46vw",
          height: "46vw",
          background: dark
            ? "radial-gradient(circle, rgba(0,178,169,.45), transparent 68%)"
            : "radial-gradient(circle, rgba(0,178,169,.30), transparent 68%)",
          animationDelay: "-2s",
        }}
      />
      <div
        className="aurora-blob animate-drift"
        style={{
          top: "6%",
          right: "-12%",
          width: "42vw",
          height: "42vw",
          background: dark
            ? "radial-gradient(circle, rgba(244,163,64,.38), transparent 68%)"
            : "radial-gradient(circle, rgba(244,163,64,.28), transparent 68%)",
          animationDelay: "-9s",
        }}
      />
      <div
        className="aurora-blob animate-drift"
        style={{
          bottom: "-18%",
          left: "28%",
          width: "40vw",
          height: "40vw",
          background: dark
            ? "radial-gradient(circle, rgba(63,217,207,.28), transparent 70%)"
            : "radial-gradient(circle, rgba(255,138,122,.20), transparent 70%)",
          animationDelay: "-15s",
        }}
      />
    </div>
  );
};

export default Aurora;
